import React from 'react'
import { Link } from 'react-router-dom'

// 渲染桌面端顶部导航菜单
const DesktopMenu = () => {
  return (

      <section className="creatyea-padding custom-navbar-menu">
        <Link className="left-side" to="/products">
          All Products
        </Link>
        <Link className="left-side" to="/odm_services">
          ODM Services
        </Link>
        <div className="spacer"></div>
        <Link className="right-side" to="/get_quote">
          PCB Quote
        </Link>
        <Link className="right-side" to="/request_quote">
          Reqeust a Quote
        </Link>
        <Link className="right-side" to="/about_us">
          About Us
        </Link>
        <Link className="right-side" to="/contact_us">
          Contact
        </Link>
      </section>
  );
}

export default DesktopMenu
